import { baseApi } from "configs/store-query";
import {
  AuthenticationOauthAuthenticateApiRequest,
  AuthenticationOauthAuthenticateApiResponse,
  AuthenticationOauthSignInApiRequest,
  AuthenticationOauthSignInApiResponse,
  AuthenticationOauthSignUpApiRequest,
  AuthenticationOauthSignUpApiResponse,
} from "apis/authentication/types/authentication-oauth-api";

const BASE_PATH = "/authentication/oauth";

export const authenticationOauthApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    signInOauthAuthentication: build.mutation<
      AuthenticationOauthSignInApiResponse,
      AuthenticationOauthSignInApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/sign-in`,
        method: "POST",
        ...config,
      }),
    }),
    signUpOauthAuthentication: build.mutation<
      AuthenticationOauthSignUpApiResponse,
      AuthenticationOauthSignUpApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/sign-up`,
        method: "POST",
        ...config,
      }),
    }),
    authenticateOauthAuthentication: build.mutation<
      AuthenticationOauthAuthenticateApiResponse,
      AuthenticationOauthAuthenticateApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/authenticate`,
        method: "POST",
        ...config,
      }),
    }),
  }),
});
